


























import { Component, Prop, Watch, Vue } from 'vue-property-decorator';

@Component
export default class Checkbox extends Vue {
  public syncedValue = false;

  @Prop(String) private id!: string;
  @Prop(Boolean) readonly value!: boolean;

  mounted() {
    this.$nextTick(() => {
      this.syncedValue = this.value;
    });
  }

  @Watch('syncedValue')
  onValueChanged(val: string) {
    this.$emit('input', val);
  }
}
